<template>
  <PageLayout title="Rozpočet a plán" :prev="prevRoute" :next="nextRoute">
    <ui-box label="Rozpočet" class="mb-4">
      <v-row class="my-n2">
        <v-col cols="6" md="3">
          <v-select
            v-model="budgetType"
            outlined
            hide-details
            :items="adsBudgetTypes"
            item-text="name"
            item-value="key"
          />
        </v-col>
        <v-col cols="6" md="3">
          <v-text-field
            outlined
            hide-details
            suffix="Kč"
            type="number"
            min="1"
            v-model="budgetValue"
          />
        </v-col>
      </v-row>
    </ui-box>
    <ui-box label="Datum a čas začátku" class="mb-4">
      <v-row class="my-n2">
        <v-col cols="6" md="3">
          <ui-date-picker v-model="dateFrom" :min="currentDate" />
        </v-col>
        <v-col cols="6" md="3">
          <ui-time-picker v-model="timeFrom" />
        </v-col>
      </v-row>
    </ui-box>
    <v-checkbox v-model="endTimeEnabled" label="Nastavit datum konce" />
    <ui-box v-if="endTimeEnabled" label="Datum a čas konce" class="mb-4">
      <v-row class="my-n2">
        <v-col cols="6" md="3">
          <ui-date-picker v-model="dateTo" :min="dateFrom" />
        </v-col>
        <v-col cols="6" md="3">
          <ui-time-picker v-model="timeTo" />
        </v-col>
      </v-row>
    </ui-box>
  </PageLayout>
</template>

<script>
import { get, sync } from "vuex-pathify"

import PageLayout from "@/components/page/ads/edit/PageLayout.vue"

export default {
  name: "AdBudget",
  components: {
    PageLayout,
  },
  props: {
    id: {
      type: String,
      default: null,
    },
    nextRoute: {
      type: String,
      default: null,
    },
    prevRoute: {
      type: String,
      default: null,
    },
    storeNamespace: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...get("enumerations", ["adsBudgetTypes"]),
    // ...sync("adDraft/model@adset", [
    //   "budget",
    //   "budgetType",
    //   "endTime",
    //   "endTimeEnabled",
    //   "startTime",
    // ]),
    currentDate() {
      const d = new Date()
      return d.toISOString().split("T")[0]
    },
    budgetValue: {
      get() {
        return this.budgetType === "daily"
          ? Math.floor(this.dailyBudget / 100)
          : Math.floor(this.lifetimeBudget / 100)
      },
      set(val) {
        if (this.budgetType === "daily") {
          this.dailyBudget = val * 100
        } else {
          this.lifetimeBudget = val * 100
        }
      },
    },
    dateFrom: {
      get() {
        return this.getDate(this.startTime)
      },
      set(val) {
        this.startTime = this.setDate(this.startTime, val)

        if (this.dateTo < this.dateFrom) {
          this.endTime = this.setDate(this.endTime, val)

          if (this.endTime < this.startTime) {
            this.endTime = this.startTime
          }
        }
      },
    },
    timeFrom: {
      get() {
        return this.getTime(this.startTime)
      },
      set(val) {
        this.startTime = this.setTime(this.startTime, val)
      },
    },
    dateTo: {
      get() {
        return this.getDate(this.endTime, this.dateFrom)
      },
      set(val) {
        this.endTime = this.setDate(this.endTime, val)
      },
    },
    timeTo: {
      get() {
        return this.getTime(this.endTime)
      },
      set(val) {
        this.endTime = this.setTime(this.endTime, val)
      },
    },
  },
  methods: {
    currentDateTime(initial = null) {
      const date = initial ? new Date(initial) : new Date()

      return date.toISOString().split(".")[0]
    },
    getDate(source, initial = null) {
      if (!source) {
        source = this.currentDateTime(initial)
      }

      return source.split("T")[0]
    },
    getTime(source, initial = null) {
      if (!source) {
        source = this.currentDateTime(initial)
      }

      return source.split("T")[1]
    },
    setDate(dest, value) {
      if (!dest) {
        dest = this.currentDateTime()
      }

      return [value, this.getTime(dest)].join("T")
    },
    setTime(dest, value) {
      if (!dest) {
        dest = this.currentDateTime()
      }

      return [this.getDate(dest), value].join("T")
    },
  },
  beforeMount() {
    if (!this.startTime) {
      this.startTime = this.currentDateTime()
    }
    if (!this.endTime) {
      this.endTime = this.startTime
    }
  },
  beforeCreate() {
    const storeNamespace = this.$options.propsData.storeNamespace

    if (!this.$options.computed) {
      this.$options.computed = {}
    }

    Object.assign(this.$options.computed, {
      ...sync(`${storeNamespace}/model@adset`, [
        "budget",
        "dailyBudget",
        "lifetimeBudget",
        "budgetType",
        "endTime",
        "endTimeEnabled",
        "startTime",
      ]),
    })
  },
}
</script>
